import styled from 'styled-components'

export const HeadingWrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 24px;
`

export const HeadingContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 40px;

  padding-bottom: 40px;
  border-bottom: 1px solid #555;
  transition: all 0.2s ease-in-out;

  @media (max-width: 1200px) {
    gap: 24px;
    align-items: center;
    padding-bottom: 30px;
  }

  @media (max-width: 630px) {
    gap: 16px;
    padding-top: 20px;
    padding-bottom: 20px;
  }
`

export const HeadingTitle = styled.h1`
	font-family: 'e-Ukraine-Head', sans-serif;
	font-weight: 400;
	font-size: 48px;
	line-height: 110%;
	text-transform: uppercase;
	color: #555;
	margin: 0;
	flex-basis: 45%;
	max-width: 45%;

	@media (max-width: 1200px) {
		font-size: 36px;
	}

	@media (max-width: 768px) {
		font-size: 28px; 
	}

	@media (max-width: 630px) {
		font-size: 16px; 
	}
`

export const HeadingText = styled.p`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 16px;
	line-height: 140%;
	text-align: justify;
	color: #484848;
	margin: 0;

	flex-basis: 55%;
	max-width: 730px;

	@media (max-width: 1200px) {
		font-size: 15px;
	}

	@media (max-width: 768px) {
		font-size: 12px;
		text-align: left;
	}

	@media (max-width: 630px) {
		font-size: 11px; 
		line-height: 130%;
	}
`
